import map from 'lodash/map'
import { useAppSettings } from '../useAppSettings/index'
import find from 'lodash/find'

/**
 * TODO: This should be obfuscated for security reason, but for now, it's fine
 */
export const useQzRemoteCert = (): {
  certificate: string
  signature: string
} => {
  enum AppSettingKeys {
    QZ_TRAY_CERTIFICATE = 'QZ_TRAY_CERTIFICATE',
    QZ_TRAY_SIGNATURE = 'QZ_TRAY_SIGNATURE',
  }

  const { settings } = useAppSettings({ appSettingKeys: map(AppSettingKeys, (k) => k) })

  return {
    certificate: find(settings, { key: AppSettingKeys.QZ_TRAY_CERTIFICATE })?.value,
    signature: find(settings, { key: AppSettingKeys.QZ_TRAY_SIGNATURE })?.value,
  }
}
